<template>
    <div class="edit-buttons">
        <button
            type="button"
            class="kgr-table__action"
            :disabled="deletePaymentsDisabled"
            @click="openDeletePaymentsDialog"
        >
            <kgr-icon
                :class="{ red: !deletePaymentsDisabled }"
                :title="$t('Alle Zahlungen entfernen')"
                :disabled="deletePaymentsDisabled"
                icon-class="credit-card"
            />
        </button>
        <button
            type="button"
            class="kgr-table__action"
            @click="openPaymentsDialog"
        >
            <kgr-icon
                style="color: green;"
                :title="$t('Zahlungseingänge verwalten')"
                icon-class="credit-card"
            />
        </button>
        <button
            type="button"
            class="kgr-table__action"
            :disabled="chargebackDisabled"
            @click="openChargebackDialog"
        >
            <kgr-icon
                :class="{ red: !chargebackDisabled }"
                :title="$t('Als &quot;Rücklastschrift&quot; markieren')"
                icon-class="warning"
                :disabled="chargebackDisabled"
            />
        </button>
        <kgr-lightbox
            v-if="showChargebackDialog"
            :value="showChargebackDialog"
            :headline="$t('Als &quot;Rücklastschrift&quot; markieren')"
            scrollable
            @post-input="closeChargebackDialog"
        >
            <div
                v-if="!chargebackDisabled"
                class="kgr-row"
            >
                Möchtest du die Rechnung #{{ value.number }} als Rücklastschrift markieren?<br /><br />
                <div
                    v-if="clubDunningSettings.clubFeeForChargeback"
                    class="kgr-text kgr-text--preserveLineBreaks"
                >
                    Für die Rechnung wird der Beitrag "{{ clubDunningSettings.clubFeeForChargeback.name }}"
                    in Höhe von <span class="kgr-text kgr-text--bold">{{ clubFeeForChargebackAmount }}</span> erhoben.
                    <br />
                    Alternativ kannst du die Rechnung auch ohne zusätzlichen Beitrag
                    als Rücklastschrift markieren oder für "{{ clubDunningSettings.clubFeeForChargeback.name }}" einen
                    individuellen Preis eintragen:
                    <kgr-text-input
                        v-model="chargebackFixedPrice"
                        :label="$t('Individueller Preis')"
                    />
                </div>
                <div
                    v-else
                    class="kgr-row kgr-text kgr-text--preserveLineBreaks"
                >
                    {{ $t('Unter "Beitragsverwaltung > Mahnwesen > Zahlungsfristen" kannst du einen Standard-Beitrag für Rücklastschriften definieren.') }}
                </div>
                <label class="kgr-inputGroup">
                    <span class="kgr-inputGroup__label">{{ $t('Grund für die Rücklastschrift') }}</span>
                    <kgr-generic-select
                        v-model="chargebackReason"
                        display="text"
                        :options="chargebackReasons"
                    />
                </label>
            </div>
            <template #footer>
                <button
                    class="kgr-button"
                    @click="closeChargebackDialog"
                >
                    {{ $t('cancel') }}
                </button>
                <button
                    class="kgr-button kgr-button--accent"
                    @click="setChargeback(true);"
                >
                    {{ $t('Ohne Beitrag') }}
                </button>
                <button
                    class="kgr-button kgr-button--accent"
                    @click="setChargeback(false);"
                >
                    {{ $t('OK') }}
                </button>
            </template>
        </kgr-lightbox>
        <kgr-lightbox
            v-if="showPaymentsDialog"
            :value="showPaymentsDialog"
            :headline="$t('Zahlungseingänge verwalten')"
            scrollable
            @post-input="closePaymentsDialog"
        >
            <div
                class="kgr-row"
            >
                <kgr-form-row
                    :label="$t('Eingangsdatum')"
                    :error="error"
                    field-name="appliedAt"
                >
                    <kgr-date-picker
                        v-model="appliedAt"
                    />
                </kgr-form-row>
            </div>
            <div class="kgr-row kgr-postfix kgr-postfix--bottom kgr-postfix--gutters">
                <div class="kgr-postfix__fixed">
                    <kgr-text-input
                        v-model="amount"
                        :label="$t('Betrag')"
                    />
                </div>
                <div class="kgr-postfix__fixed">
                    <kgr-generic-select
                        v-model="currency"
                        disabled
                        :translate-values="false"
                        :options="currencies"
                    />
                </div>
                <div class="kgr-postfix__fluid">
                    <kgr-text-input
                        v-model="note"
                        :label="$t('Notiz')"
                    />
                </div>
            </div>
            <div class="kgr-row">
                <table class="kgr-table kgr-table--block kgr-table--striped printable">
                    <thead>
                        <tr class="kgr-table__row">
                            <th
                                class="kgr-table__cell kgr-table__cell--headline"
                                colspan="5"
                            >
                                {{ $t('Bisherige Zahlungen') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="hasPayments">
                        <tr
                            v-for="payment in paymentsExceptDunningAndChargebackFees"

                            :key="payment.id"
                            class="kgr-table__row"
                        >
                            <td
                                class="kgr-table__cell"
                            >
                                {{ payment.appliedAt }}
                            </td>
                            <td
                                class="kgr-table__cell"
                            >
                                {{ payment.formattedMoney }}
                            </td>
                            <td
                                class="kgr-table__cell"
                            >
                                {{ payment.note }}
                            </td>
                            <td class="kgr-table__cell kgr-table__cell--actions kgr-hidden-print">
                                <button
                                    v-if="payment.isChargeback() && value.chargeback !== null"
                                    class="kgr-table__action"
                                >
                                    <kgr-icon
                                        icon-class="info-circle"
                                        style="color: blue;"
                                        :title="$t('Zahlung kann nur über das Löschen der Rücklastschrift entfernt werden.')"
                                        disabled
                                        small
                                    />
                                </button>
                                <button
                                    v-else
                                    class="kgr-table__action"
                                    @click="deleteInvoicePayment(payment.id)"
                                >
                                    <kgr-icon
                                        icon-class="close"
                                        :title="$t('Zahlung löschen')"
                                        circle
                                        small
                                    />
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr><td>--</td></tr>
                    </tbody>
                </table>
            </div>
            <div class="kgr-row">
                <table class="kgr-table kgr-table--block kgr-table--striped printable">
                    <thead>
                        <tr class="kgr-table__row">
                            <th
                                class="kgr-table__cell kgr-table__cell--headline"
                            >
                                {{ $t('Rechnungsbetrag') }}
                            </th>
                            <th
                                class="kgr-table__cell kgr-table__cell--headline"
                            >
                                {{ $t('Rücklastschrift') }}
                            </th>
                            <th
                                class="kgr-table__cell kgr-table__cell--headline"
                            >
                                {{ $t('Mahngebühr') }}
                            </th>
                            <th
                                class="kgr-table__cell kgr-table__cell--headline"
                            >
                                {{ $t('Summe Zahlungen') }}
                            </th>
                            <th
                                class="kgr-table__cell kgr-table__cell--headline"
                            >
                                {{ $t('Differenz') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="hasPayments">
                        <tr
                            class="kgr-table__row"
                        >
                            <td
                                class="kgr-table__cell"
                            >
                                {{ amountInvoice }}
                            </td>
                            <td
                                class="kgr-table__cell"
                            >
                                {{ amountChargebackFee }}
                            </td>
                            <td
                                class="kgr-table__cell"
                            >
                                {{ amountDunningFee }}
                            </td>
                            <td
                                class="kgr-table__cell"
                            >
                                {{ amountPayments }}
                            </td>
                            <td
                                class="kgr-table__cell"
                            >
                                {{ amountDifference }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <template #footer>
                <button
                    class="kgr-button"
                    @click="closePaymentsDialog"
                >
                    {{ $t('cancel') }}
                </button>
                <button
                    class="kgr-button kgr-button--accent"
                    :disabled="saveButtonDisabled"
                    @click="createInvoicePayment()"
                >
                    {{ $t('Zahlung speichern') }}
                </button>
            </template>
        </kgr-lightbox>
        <kgr-lightbox
            v-if="showDeletePaymentsDialog"
            :value="showDeletePaymentsDialog"
            :headline="$t('Alle Zahlungen entfernen')"
            @post-input="closeDeletePaymentsDialog"
        >
            <div class="kgr-text kgr-text--preserveLineBreaks">
                <div
                    class="kgr-row"
                >
                    {{ $t('Mit diesem Vorgang werden alle Zahlungen an dieser Rechnung gelöscht.') }}<br /><br />
                    {{ $t('Ausgenommen davon sind Zahlungen für Mahngebühren. Diese können nur über ein Zurücksetzen des Mahnstatus gelöscht werden.') }}
                </div>
                <div
                    v-if="value.chargeback !== null"
                    class="kgr-alert kgr-alert--info kgr-alert--noIcon kgr-row"
                >
                    <span
                        class="kgr-text kgr-text--bold"
                    >
                        <kgr-icon
                            icon-class="info-circle"
                            style="margin-bottom: -5px;margin-right:5px;color:black;"
                            disabled
                            small
                        />{{ $t('Hinweis') }}</span><br />
                    {{ $t('Mit dem Löschen aller Zahlungen wird auch die Rücklastschriftgebühr entfernt') }}
                </div>
            </div>
            <template #footer>
                <button
                    class="kgr-button"
                    @click="closeDeletePaymentsDialog"
                >
                    {{ $t('cancel') }}
                </button>
                <button
                    class="kgr-button kgr-button--accent"
                    @click="deleteInvoicePayments();closeDeletePaymentsDialog();"
                >
                    {{ $t('OK') }}
                </button>
            </template>
        </kgr-lightbox>
    </div>
</template>

<script>
import { endOfToday, format, isAfter, parse } from '@legacy/js/date/date-fns.js';
import ClubDunningSettings from '../../../js/dto/ClubDunningSettings.js';
import ClubInvoice from '../../../js/dto/ClubInvoice.js';
import ClubInvoicePaymentRepository from '../../../js/repository/ClubInvoicePaymentRepository.js';
import ClubInvoiceRepository from '../../../js/repository/ClubInvoiceRepository.js';
import ClubTransactionInvoice from '../../../js/dto/ClubTransactionInvoice.js';
import DatePicker from '../../common/form/picker/DatePicker.vue';
import Error from '../../../js/model/Error.js';
import FormRow from '../../common/form/FormRow.vue';
import GenericSelect from '../../common/form/select/GenericSelect.vue';
import Helper from '../../../js/accounting/Helper.js';
import Icon from '../../common/icon/Icon.vue';
import Lightbox from '../../common/modal/Lightbox.vue';
import PriceFormatter from '../../../js/price/PriceFormatter.js';
import TextInput from '../../common/form/input/TextInput.vue';

const AMOUNT_BASE = 100;

export default {
    components: {
        'kgr-icon': Icon,
        'kgr-lightbox': Lightbox,
        'kgr-date-picker': DatePicker,
        'kgr-text-input': TextInput,
        'kgr-generic-select': GenericSelect,
        'kgr-form-row': FormRow,
    },
    props: {
        value: {
            required: true,
            validator(value) {
                return value instanceof ClubInvoice || value instanceof ClubTransactionInvoice;
            },
        },
        clubDunningSettings: {
            type: ClubDunningSettings,
            required: true,
        },
        locale: {
            type: String,
            required: false,
            default: 'de-DE',
        },
    },
    data() {
        return {
            error: new Error(),
            helper: new Helper(),
            appliedAt: format(new Date(), 'dd.MM.yyyy'),
            showDeletePaymentsDialog: false,
            showChargebackDialog: false,
            showPaymentsDialog: false,
            amount: '',
            note: '',
            invoiceId: null,
            amountInvoice: null,
            amountChargebackFee: null,
            amountDunningFee: null,
            amountPayments: null,
            amountDifference: null,
            paymentDifference: 0,
            currency: 'EUR',
            currencies: [
                'EUR',
                'USD',
            ],
            chargebackFixedPrice: '',
            chargebackReasons: [
                { value: 'lackOfCover', text: this.$t('Mangels Deckung') },
                { value: 'contradiction', text: this.$t('Aufgrund von Widerspruch') },
                { value: 'accountDoesNotExist', text: this.$t('Konto existiert nicht') },
            ],
            chargebackReason: null,
        };
    },
    computed: {
        chargebackDisabled() {
            return this.value.status === ClubInvoice.STATUS_CHARGEBACK
                || this.value.paymentMethod !== ClubInvoice.PAYMENT_METHOD_SEPA_DEBIT
                || this.value.payments.length === 0
                || this.value.chargeback != null
                || this.paymentDifference !== 0
                || this.value.canceled
            ;
        },
        deletePaymentsDisabled() {
            const paymentsCount = this.value.payments.length;
            return paymentsCount === 0
                || (paymentsCount === 1 && this.value.payments[0].isDunningFee)
                || (paymentsCount === 1 && this.value.payments[0].isChargebackFee());
        },
        saveButtonDisabled() {
            if (Number(this.amount.replace(',', '.')) === 0) {
                return true;
            }
            const reg = new RegExp(/^-?\d+([.,]\d{1,2})?$/);
            return !reg.test(this.amount);
        },
        hasPayments() {
            return this.value.payments.length > 0;
        },
        paymentsExceptDunningAndChargebackFees() {
            return this.value.payments.filter((payment) => !payment.isDunningFee && !payment.isChargebackFee());
        },
        clubFeeForChargebackAmount() {
            if (this.clubDunningSettings.clubFeeForChargeback === null) {
                return null;
            }
            const currentPrice = this.clubDunningSettings.clubFeeForChargeback.priceHistory.getCurrentPricePerTime();
            return new PriceFormatter().format(currentPrice);
        },
        convertedFixedPriceDiscount() {
            if (this.chargebackFixedPrice === null || this.chargebackFixedPrice === '') {
                return null;
            }
            const amount = Number((this.chargebackFixedPrice.replace(',', '.') * AMOUNT_BASE).toFixed(0));
            return {
                amount: { numerator: amount, denominator: AMOUNT_BASE },
                currency: this.currency,
                netOrGross: 'gross',
                vat: { numerator: 0, denominator: AMOUNT_BASE },
            };
        },
    },
    watch: {
        value() {
            this.calcAmounts();
        },
        'value.payments': function () {
            this.calcAmounts();
        },
    },
    created() {
        this.currency = this.value.currency;
        this.calcAmounts();
        this.invoiceId = this.value instanceof ClubInvoice ? this.value.id : this.value.invoiceId;
    },
    methods: {
        deleteInvoicePayments() {
            ClubInvoicePaymentRepository.deleteByClubInvoiceId(this.invoiceId)
                .then(() => this.emitInvoiceReload());
        },
        setChargeback(ignoreClubFee) {
            const date = new Date();
            const clubFeeId = this.clubDunningSettings.clubFeeForChargeback !== null
                ? this.clubDunningSettings.clubFeeForChargeback.id
                : null;
            const data = {
                appliedAt: { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() },
                clubFeeId: ignoreClubFee === true ? null : clubFeeId,
                fixedPriceDiscount: ignoreClubFee === true ? null : this.convertedFixedPriceDiscount,
                reason: this.chargebackReason?.value,
            };
            ClubInvoiceRepository.setChargeback(this.invoiceId, data)
                .then(() => {
                    this.chargebackFixedPrice = '';
                    this.$emit('invoiceReloadWithPolling');
                    this.closeChargebackDialog();
                })
                .catch(() => this.$notify.error('saveChanges.error'));
        },
        createInvoicePayment() {
            const error = new Error();
            const date = parse(this.appliedAt, 'dd.MM.yyyy', new Date());
            if (!date) {
                error.add('appliedAt', this.$t('Bitte gib ein gültiges Datum ein.'));
                this.error = error;
                return;
            }

            if (isAfter(date, endOfToday())) {
                error.add('appliedAt', this.$t('Das Datum darf nicht in der Zukunft liegen.'));
            } else {
                error.clear('appliedAt');
            }
            this.error = error;
            if (!this.error.isEmpty()) {
                return;
            }
            const amount = Number((this.amount.replace(',', '.') * AMOUNT_BASE).toFixed(0));
            const data
                = {
                    money: { amount: { numerator: amount, denominator: AMOUNT_BASE }, currency: this.currency },
                    appliedAt: { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() },
                    note: this.note,
                };
            ClubInvoicePaymentRepository.createByClubInvoiceId(this.invoiceId, data)
                .then(() => {
                    this.emitInvoiceReload();
                    this.appliedAt = format(new Date(), 'dd.MM.yyyy');
                    this.closePaymentsDialog();
                })
                .catch((error) => {
                    this.$notify.error('saveChanges.error');
                    this.error = error;
                });
        },
        deleteInvoicePayment(paymentId) {
            showConfirm(this.$t('confirmInformal'), this.$t('Willst du die Zahlung wirklich löschen?'), () => {
                ClubInvoicePaymentRepository.deleteById(paymentId)
                    .then(() => this.emitInvoiceReload());
            }, this.$t('Zahlung löschen'));
        },
        emitInvoiceReload() {
            this.$emit('invoiceReload', true);
        },
        calcAmounts() {
            let invoiceAmount = this.value.gross.data.numerator / this.value.gross.data.denominator;
            if (this.value.canceled) {
                const canceledAmount = invoiceAmount;
                invoiceAmount = 0;
                this.amountInvoice = `${this.formatCurrency(0)} (${this.formatCurrency(canceledAmount)} vor Storno)`;
            } else {
                this.amountInvoice = this.formatCurrency(invoiceAmount);
            }
            this.amountChargebackFee = null;
            this.amountDunningFee = null;
            let sumPayments = 0.0;
            let dunningFeeAmount = 0.0;
            let chargebackFeeAmount = 0.0;
            this.value.payments.forEach((payment) => {
                if (payment.isDunningFee) {
                    dunningFeeAmount = payment.money.numerator / payment.money.denominator;
                    if (dunningFeeAmount < 0) {
                        dunningFeeAmount = dunningFeeAmount * -1;
                    }
                    this.amountDunningFee = this.formatCurrency(dunningFeeAmount);
                } else if (payment.isChargebackFee()) {
                    chargebackFeeAmount = (payment.money.numerator / payment.money.denominator) * -1;
                    this.amountChargebackFee = this.formatCurrency(chargebackFeeAmount);
                } else {
                    sumPayments += payment.money.numerator / payment.money.denominator;
                }
            });
            this.amountPayments = this.formatCurrency(sumPayments);
            let difference = Math.round((invoiceAmount + dunningFeeAmount + chargebackFeeAmount - sumPayments) * 100) / 100 || 0;
            this.amount = this.formatNumber(difference).replace('.', '');
            difference = difference !== 0 ? difference * -1 : difference;
            this.amountDifference = (difference > 0 ? '+' : '') + this.formatCurrency(difference);
            this.paymentDifference = difference;
        },
        formatCurrency(amount) {
            return this.helper.numberFormat(amount, this.locale, this.currency);
        },
        formatNumber(amount) {
            return this.helper.numberFormat(amount, this.locale);
        },
        openDeletePaymentsDialog() {
            this.showDeletePaymentsDialog = true;
        },
        closeDeletePaymentsDialog() {
            this.showDeletePaymentsDialog = false;
        },
        openChargebackDialog() {
            this.showChargebackDialog = true;
        },
        closeChargebackDialog() {
            this.showChargebackDialog = false;
        },
        openPaymentsDialog() {
            this.showPaymentsDialog = true;
        },
        closePaymentsDialog() {
            this.showPaymentsDialog = false;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .edit-buttons {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
}
.red {
    color: red;
}
</style>
